export var animateModal = function(element, duration, marginsFrom, marginsTo, onComplete) {
    var start = performance.now();
    var easing = "cubic-bezier(0.075, 0.82, 0.165, 1)";
    var animateLeftRight = function() {
        var animate = function(time) {
            var timeFraction = (time - start) / duration;
            var progress = Math.min(timeFraction, 1);
            var currentLeft = marginsFrom.left + (marginsTo.left - marginsFrom.left) * progress;
            var currentRight = marginsFrom.right + (marginsTo.right - marginsFrom.right) * progress;
            var currentTop = marginsFrom.top + (marginsTo.top - marginsFrom.top) * progress;
            var currentBottom = marginsFrom.bottom + (marginsTo.bottom - marginsFrom.bottom) * progress;
            element.style.top = "".concat(currentTop, "px");
            element.style.bottom = "".concat(currentBottom, "px");
            element.style.left = "".concat(currentLeft, "px");
            element.style.right = "".concat(currentRight, "px");
            if (timeFraction < 1) {
                requestAnimationFrame(animate);
            } else if (onComplete) {
                onComplete();
            }
        };
        element.style.transitionTimingFunction = easing;
        requestAnimationFrame(function() {
            element.style.transition = "left ".concat(duration, "ms ").concat(easing, ", right ").concat(duration, "ms ").concat(easing);
            requestAnimationFrame(animate);
        });
    };
    element.style.transitionTimingFunction = easing;
    requestAnimationFrame(function() {
        element.style.transition = "top ".concat(duration, "ms ").concat(easing, ", bottom ").concat(duration, "ms ").concat(easing);
        requestAnimationFrame(animateLeftRight);
    });
};
